import React from 'react';
// import { TiHtml5, TiCss3 } from '@tabler/icons';

import ProgressBar from "@ramonak/react-progress-bar";


const Frontend = () => {
  return (
    <div className="skills__content">
      <h3 className="skills__title">Frontend Developer</h3>
      
        <div className="skills__box">
        
          <div className="skills__group">
              <div className="skills__data">
              <i className="bx bxl-html5"></i>
              <div>
                <h3 className="skills__name">HTML5</h3>
              <ProgressBar 
                  completedClassName="barCompleted"
                  labelClassName="label"
                  className="skills__level"
                  completed={80} 
              />
                {/* <span className="skills__level">Advanced</span> */}
              </div>
              
              </div>
              
              <div className="skills__data">
                <i className="bx bxl-css3"></i>
                {/* <IconBrandCss3  /> */}
                <div>
                  <h3 className="skills__name">CSS3</h3>
              <ProgressBar 
                completedClassName="barCompleted"
                labelClassName="label"
                className="skills__level"
                completed={100} 
              />
                  {/* <span className="skills__level">Advanced</span> */}
                </div>
              </div>
              
              <div className="skills__data">
                <i className="bx bxl-sass"></i>
                <div>
                  <h3 className="skills__name">Sass</h3>
                <ProgressBar 
                  completed={90} 
                  completedClassName="barCompleted"
                  labelClassName="label"
                  className="skills__level"
                />
                  {/* <span className="skills__level">Advanced</span> */}
                </div>
              </div>
              
              <div className="skills__data">
              <i className="bx bxl-javascript"></i>
              {/* <IconBrandJavascript /> */}
              <div>
                <h3 className="skills__name">Javascript</h3>
              <ProgressBar 
                completedClassName="barCompleted"
                labelClassName="label"
                className="skills__level"
                completed={80} 
              />
                {/* <span className="skills__level">Master</span> */}
              </div>
              
              </div>
          </div> 
          
          
          <div className="skills__group">
              <div className="skills__data">
              <i className="bx bxl-bootstrap"></i>
              {/* <IconBrandBootstrap /> */}
              <div>
                <h3 className="skills__name">Bootstrap</h3>
                {/* <span className="skills__level">Intermediate</span> */}
                <ProgressBar 
                  completedClassName="barCompleted"
                  labelClassName="label"
                  className="skills__level"
                  completed={60} 
              />
              </div>
              
              </div>
              
            <div className="skills__data">
              <i className="bx bxl-react"></i>
              <div>
                <h3 className="skills__name">ReactJs</h3>
                <ProgressBar 
                  completedClassName="barCompleted"
                  labelClassName="label"
                  className="skills__level"
                  completed={86} 
              />
                
              </div>
              
              </div>
              
              <div className="skills__data">
                <i className="bx bxl-vuejs"></i>
                <div>
                  <h3 className="skills__name">VueJs</h3>
                <ProgressBar 
                  completedClassName="barCompleted"
                  labelClassName="label"
                  className="skills__level"
                  completed={70} 
              />
                  {/* <span className="skills__level">Master</span> */}
                </div>
              </div>
              
            <div className="skills__data">
              <i className="bx bxl-tailwind-css"></i>
              {/* <IconBrandTailwind  /> */}
              <div>
                <h3 className="skills__name">Tailwind</h3>
                <ProgressBar 
                  completedClassName="barCompleted"
                  labelClassName="label"
                  className="skills__level"
                  completed={60} 
              />
                {/* <span className="skills__level">Masteral</span> */}
              </div>
              
              </div>
          </div> 
        </div>
    </div>
  )
}

export default Frontend;
